import Vue from 'vue';
import VueRouter from "vue-router";
import menu from '../view/menu'

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    redirect: '/page404',
    meta: {notToken: true}
  },
  {
    path: '/',
    redirect: '/myMenu/shop',
    meta: {notToken: true}
  },
  {
    path: '/page404',
    component: () => import('@/view/page404'),
    name: 'Page404',
    meta: {notToken: true}
  },
  {
    path: '/login',
    component: () => import('@/view/login'),
    name: 'Login'
  },
  {
    path: '/register',
    component: () => import('@/view/register'),
    name: 'Register'
  },
  {
    path: '/myOrder',
    component: () => import('@/view/myOrder/index'),
    name: 'MyOrder',
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/orderDetail',
    component: () => import('@/view/orderDetail/index'),
    name: 'OrderDetail'
  },
  {
    path: '/doorList',
    component: () => import('@/view/doorList/index'),
    name: 'DoorList'
  },
  {
    path: '/doorInfo',
    component: () => import('@/view/doorInfo/index'),
    name: 'DoorInfo'
  },
  {
    path: '/shopInfo',
    component: () => import('@/view/shopInfo/index'),
    name: 'ShopInfo'
  },
  {
    path: '/orderShopSearch',
    name: 'OrderShopSearch',
    component: () => import('@/view/myOrder/orderShopSearch/index')
  },
  {
    path: '/myMenu',
    component: menu,
    redirect: '/myMenu/mine',
    name: 'MyMenu',
    children: [
      // {
      //   path: 'notice',
      //   component: () => import('@/view/notice/index'),
      //   name: 'Notice'
      // },
      {
        path: 'buyCart',
        name: 'BuyCart',
        component: () => import('@/view/MyMenu/buyCart/index')
      },
      {
        path: 'mine',
        name: 'mine',
        component: () => import('@/view/MyMenu/mine/index')
      },
      {
        path: 'shop',
        name: 'Shop',
        component: () => import('@/view/MyMenu/shop/index'),
        meta: {notToken: true}
      },
      {
        path: 'shopSearch',
        name: 'ShopSearch',
        component: () => import('@/view/MyMenu/shopSearch/index'),
        meta: {notToken: true}
      },
      // {
      //   path: 'shopInquire',
      //   component: () => import('@/view/shopInquire/index'),
      //   name: 'ShopInquire',
      //   meta: {notToken: true}
      // },
      // {
      //   path: 'shopList',
      //   component: () => import('@/view/shopList/index'),
      //   name: 'ShopList'
      // }
    ]
  }
]

const router = new VueRouter({
  scrollBehavior: () => ({
    y: 0
  }),
  routes
});

export default router;
